import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-sessions-topics-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class SessionsTopicsHeaderComponent {
  @Input() newIdea = false;
}
